:host {
  display: inline-flex;
  --toggle-box-height: var(--p-size-static-300);
  --toggle-box-width: var(--p-size-static-500);
  --toggle-border-width: var(--s-size-border-width-default);

  --toggle-radius: 126px;
  
  --toggle-color: var(--s-color-background-default-default);
  --toggle-disabled-color: var(--toggle-color);
  --toggle-hover-color: var(--s-color-background-default-default);
  --toggle-checked-color: var(--b-color-neutral-darker);
  --toggle-checked-hover-color: var(--b-color-black);
  --toggle-checked-disabled-color: var(--p-color-stone-400);
  --toggle-disabled-color: var(--s-color-background-default-default);
  
  --toggle-text-color: var(--s-color-text-default);

  --toggle-border-color: var(--b-color-neutral-darker);
  --toggle-border-disabled-color: var(--p-color-stone-400);
}

.anchor-c-toggle {
  --cursor: pointer;
  background: transparent;
  display: flex;
  position: relative;
  cursor: var(--cursor);
  outline: 0;

  &--disabled {
    --toggle-text-color: var(--s-color-text-disabled);
    label:hover {
      --toggle-cursor: not-allowed;
    }
  }

  &--input {
    margin: 0;
    appearance: none;
    pointer-events: none;
    background-color: var(--toggle-color);
    border: var(--toggle-border-width) solid var(--toggle-border-color);
    height: var(--toggle-box-height);
    min-width: var(--toggle-box-width);
    border-radius: var(--toggle-radius);
    transition: background-color 0.2s;
    position: relative;
    user-select: none;
    
    &:before {
      content: "";
      display: block;
      position: absolute;
      background-color: var(--b-color-black);
      border-radius: 100%;
      transition: all 0.2s;
      width: calc(var(--toggle-box-height) - var(--p-size-static-100));
      height: calc(var(--toggle-box-height) - var(--p-size-static-100));
      margin: calc((var(--p-size-static-100) / 2) - var(--toggle-border-width));
      left: 0;
      user-select: none;
    }

    &:checked {
      --toggle-color: var(--toggle-checked-color);
      &:hover {
        --toggle-color: var(--toggle-checked-hover-color);
      }
      &:before {
        left: calc(100% - (var(--toggle-box-height) - (var(--p-size-static-100) / 2)));
        background-color: var(--b-color-white);
      }
    }
    &:disabled {
      --toggle-color: var(--toggle-disabled-color)
      --toggle-border-color: var(--toggle-border-disabled-color);
      --cursor: not-allowed;
      &:before {
        background-color: var(--toggle-border-disabled-color);
      }
    }
    &:disabled:checked {
      --toggle-color: var(--toggle-checked-disabled-color);
      &:before {
        background-color: var(--b-color-white);
      }
    }
  }

  &:focus-visible {
    .anchor-c-toggle--input:not(:disabled) {
      --border-color: var(--s-color-outline-default);
      outline: var(--s-color-outline-default) solid var(--s-size-outline-focus-ring-width);
      outline-offset: var(--s-size-outline-focus-ring-offset);
    }
  }
  &:hover {
    .anchor-c-toggle--input:not(:disabled) {
      --border-color: var(--b-color-black);
      outline: var(--s-color-outline-aura-hover) solid var(--s-size-outline-aura-width);
    }
  }
  &:active {
    .anchor-c-toggle--input:not(:disabled) {
      outline: var(--s-color-outline-aura-pressed) solid var(--s-size-outline-aura-width);
    }
  }

  label {
    font-family: inherit;
    font-size: var(--s-size-text-default);
    line-height: var(--p-size-dynamic-300);
    padding: var(--p-size-static-150) 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--p-size-static-200);
    color: var(--toggle-text-color);

    &:hover {
      cursor: var(--cursor);
    }
    ::slotted([slot|='help-text']) {
      display: block;
      font-weight: 300;
    }
  }
}
